import {
    faAddressCard,
    faArrowLeft,
    faStar,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useMutation, useQuery } from '@tanstack/react-query';
import { Link, useParams } from 'react-router-dom';
import { useAlert } from '../../../../AlertProvider';
import Button from '../../../../components/Button';
import ButtonLink from '../../../../components/ButtonLink';
import Divider from '../../../../components/Divider';
import Loader from '../../../../components/Loader';
import NotFound from '../../../../components/NotFound';
import { alertType } from '../../../../constants/alertTypeConstant';
import { contactPage } from '../../../../constants/pagesRoutesContants';
import { successStatus } from '../../../../constants/requestStatusContants';
import Role from '../../../../enums/RoleEnum';
import { postContactLawyerBookmark } from '../../../../services/bookmarkService';
import { fetchUserById } from '../../../../services/userService';
import LawyerCalendar from '../../../lawyers/lawyer/calendar';
import styles from './style.module.scss';

function Contact() {
    const { contactId = '' } = useParams();
    const alert = useAlert();

    const { data: user, isPending } = useQuery({
        queryKey: ['getUser', contactId],
        queryFn: async () => {
            if (contactId.length === 0) {
                return null;
            }
            const { data } = await fetchUserById(contactId);
            return data;
        },
    });

    const { mutate } = useMutation({
        mutationFn: async (id: string) => {
            const { data, status } = await postContactLawyerBookmark(id);
            if (successStatus.includes(status)) {
                alert.show({
                    children:
                        'Vos modifications ont été enregistrées avec succès',
                    type: alertType[status],
                });
            } else {
                alert.show({
                    children:
                        'Erreur! Une erreur est survenue. Veuillez réessayer plus tard.',
                    type: alertType[status],
                });
            }
            return data;
        },
    });

    const handleClickFavori = () => {
        if (contactId) {
            mutate(contactId);
        }
    };

    if (isPending) {
        return <Loader />;
    }
    if (!user) {
        return <NotFound />;
    }

    return (
        <div className={styles.body}>
            <div className={styles.header}>
                <Link to={contactPage.path}>
                    <FontAwesomeIcon icon={faArrowLeft} />
                </Link>
                <h1 className={styles.title}>
                    <span className={styles.headerIcon}>
                        <FontAwesomeIcon icon={faAddressCard} />
                    </span>
                    Contact
                </h1>
            </div>
            <Divider marginBottom="20px" />
            <div className={styles.userInfoContainer}>
                <div className={styles.userProfile}>
                    <img
                        src="https://via.placeholder.com/150"
                        alt="UserProfilePicture"
                        className={styles.profilePicture}
                    />
                    <h2 className={styles.userName}>
                        {user.firstName} {user.lastName}
                    </h2>
                </div>
                <div className={styles.favBtn}>
                    <Button variant="secondary" onClick={handleClickFavori}>
                        <FontAwesomeIcon icon={faStar} />
                    </Button>
                </div>
                <div className={styles.userDetails}>
                    <div className={styles.contactRow}>
                        <div className={styles.contactRowTitle}>
                            <strong>Cabinet :</strong>
                        </div>
                        <div className={styles.contactRowData}>
                            {user.lawyer.lawfirm}
                        </div>
                    </div>
                    <div className={styles.contactRow}>
                        <div className={styles.contactRowTitle}>
                            <strong>Adresse :</strong>
                        </div>
                        <div className={styles.contactRowData}>
                            {user.lawyer.address}
                        </div>
                    </div>
                    <div className={styles.contactRow}>
                        <div className={styles.contactRowTitle}>
                            <strong>Email :</strong>
                        </div>
                        <div className={styles.contactRowData}>
                            {user.lawyer.email}
                        </div>
                    </div>
                    <div className={styles.contactRow}>
                        <div className={styles.contactRowTitle}>
                            <strong>Téléphone :</strong>
                        </div>
                        <div className={styles.contactRowData}>
                            {user.lawyer.phone}
                        </div>
                    </div>

                    <div className={styles.contactBtn}>
                        <ButtonLink link={'/profile/messages'}>
                            Contacter
                        </ButtonLink>
                    </div>
                </div>
            </div>
            {user.role === Role.Lawyer && (
                <LawyerCalendar lawyer={user.lawyer} />
            )}
        </div>
    );
}

export default Contact;
